import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Bygningsstatushistorikk from './Bygningsstatushistorikk.jsx'
import BygningsstatushistorikkIcon from '../../../images/Bygningsstatushistorikk.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class BygningsstatushistorikkList extends Component {
    state = {
        bygningsstatusHistorikker: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getBygningsstatushistorikker = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}/bygningsstatushistorikk`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                bygningsstatusHistorikker: [...this.state.bygningsstatusHistorikker, ...data.bygningsstatusHistorikker],
                isLoading: false,
                continuationToken: data.nextContinuationToken})
        })
      }


    toggleBygningsstatushistorikker = () => {
        if (this.props.antall == 0) return
                
        if (this.state.bygningsstatusHistorikker.length == 0) {
            this.getBygningsstatushistorikker()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallBygningsstatushistorikker = this.state.continuationToken ? `${this.state.bygningsstatusHistorikker.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleBygningsstatushistorikker}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={BygningsstatushistorikkIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('bygningstatushistorikker')} ({antallBygningsstatushistorikker})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.bygningsstatusHistorikker.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.bygningsstatusHistorikker.map((b, index) => { return (<Bygningsstatushistorikk key={b.bygningsstatusHistorikkId} bygningsstatushistorikk={b} antall={this.props.antall} isLast={index==this.state.bygningsstatusHistorikker.length-1} onEvent={this.props.onEvent} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getBygningsstatushistorikker}>
                                <span>{t('hent.bygningsstatushistorikker')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(BygningsstatushistorikkList)